import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BoardThumbnail from "~/components/BoardThumbnail/BoardThumbnail";
import { DRAG_PREVIEW_HEIGHT, DRAG_PREVIEW_WIDTH } from "~/constants/dnd";
export const DNDBoardGalleryCardDragPreview = (param)=>{
    let { board } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex grow",
        children: [
            /*#__PURE__*/ _jsx(BoardThumbnail, {
                board: board,
                sizes: "228px",
                width: DRAG_PREVIEW_WIDTH - 8,
                height: DRAG_PREVIEW_HEIGHT - 8
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute inset-0 flex items-end bg-black/30",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "truncate p-2 text-24 font-semibold text-white",
                    children: board.title
                })
            })
        ]
    });
};
